import { useState, useEffect, useRef, useCallback } from "react";
export function useStateCallback(initialState) {
	const [state, setState] = useState(initialState);
	const cbRef = useRef(null);
	const setStateCallback = useCallback((stateNew, cb) => {
		cbRef.current = cb;
		setState(stateNew);
	}, []);

	useEffect(() => {
		if (cbRef.current) {
			cbRef.current(state);
			cbRef.current = null;
		}
	}, [state]);

	return [state, setStateCallback];
}
